/** 偏好持久化：Phase 1 尚无后端，先落 localStorage，接口形态与 settings 表对齐。 */

const PREFIX = 'stock_note:';

export const storageKey = (key: string) => `${PREFIX}${key}`;

export function readSetting<T>(key: string, fallback: T): T {
  if (typeof localStorage === 'undefined') return fallback;
  try {
    const raw = localStorage.getItem(storageKey(key));
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function writeSetting(key: string, value: unknown): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(storageKey(key), JSON.stringify(value));
  } catch {
    /* 配额满或隐私模式，忽略：偏好丢失不应阻塞界面 */
  }
}

/** 主题偏好键（AppShell 与 themeContext 共用） */
export const THEME_KEY = 'theme';
